import { censusGraphsPlaceImpact } from '../census-graphs';

export const parcelReport = {
  id: 'PARCEL_REPORT',
  identifier: 'fips',
  source: 'census_history',
  sections: [
    {
      title: 'Census Block Group',
      titleSelector: 'parcels[0].name',
      properties: [
        {
          column: 'geom',
          padding: 1,
          type: 'MAP',
          options: ['HIDE_STREETVIEW', 'SINGLE_PARCEL'],
        },
        {
          type: 'ACTIONS',
          options: ['PRINT', 'DIRECTIONS'],
        },
        {
          column: 'name',
          label: 'Census Block Group',
          type: 'TEXT',
        },
        {
          column: 'fips',
          label: 'Census Block Group GeoID',
          type: 'TEXT',
        },
        {
          column: 'name_cousub',
          label: 'Municipalities',
          type: 'TEXT',
        },
        {
          column: 'name_county',
          label: 'County',
          type: 'TEXT',
        },
        ...censusGraphsPlaceImpact(),
        {
          column: 'submarket',
          label: 'Housing Market Strength',
          type: 'TEXT',
        },
        {
          column: 'housing_affordability_renters',
          label: 'Housing Affordability - Renters',
          type: 'TEXT',
        },
        {
          column: 'housing_affordability_owners',
          label: 'Housing Affordability - Owners',
          type: 'TEXT',
        },
      ],
    },
  ],
};
